<template>
  <div>
    <v-container>
      <v-row justify="center">
        <!--Card-->
        <v-col cols="12" md="9">
          <v-card class="mb-3" outlined>
            <!--Card title-->
            <v-container class="d-flex justify-center">
              <h2 class="primary--text pb-2">
                <v-icon class="mb-1" color="primary" left>mdi-face</v-icon>
                Podaci o učeniku
              </h2>
            </v-container>
            <div
              style="height: 1px; background: linear-gradient(90deg,#fff,#084776,#fff);"
            ></div>
            <!-- broj studenta u dnevniku ako se nalazimo na detaljima studenta u odjeljenju -->
            <v-row v-if="$route.name === 'StudentDetailsIndex'">
              <v-col cols="4" class="d-flex justify-end">
                <p class="font-weight-bold">Broj u dnevniku:</p>
              </v-col>
              <v-col>
                <p>
                  {{
                    enrolledStudent ? enrolledStudent.enrollment_number : "-"
                  }}
                </p>
              </v-col>
            </v-row>
            <!--Card body-->
            <v-row
              v-for="(value, propertyName, index) in studentData"
              :key="index"
            >
              <v-col cols="4" class="d-flex justify-end">
                <p class="font-weight-bold">{{ propertyName }}:</p>
              </v-col>
              <v-col>
                <p>{{ value ? value : "-" }}</p>
              </v-col>
            </v-row>
          </v-card>
          <!--Parent1 info-->
          <v-card class="mb-3" outlined>
            <!--Card title-->
            <v-container
              v-if="Object.keys(parent1Info).length !== 0"
              class="d-flex justify-center"
            >
              <v-row justify="center" align="center">
                <v-col cols="12" md="6" class="text-center">
                  <h3 class="primary--text pb-2">
                    <v-icon class="mb-1" color="primary" left
                      >mdi-account</v-icon
                    >
                    Podaci o roditelju/staratelju
                  </h3>
                </v-col>
                <v-col cols="12" md="6" class="text-center" v-if="$checkPermission('change_password_for_parents')">
                  <v-btn
                    v-if="!has_sumit_login_p1"
                    outlined
                    class="text-none"
                    color="primary"
                    @click="openDialogParent(1, 'give')"
                  >
                    <v-icon left color="red">mdi-account-key</v-icon>
                    Dodijeli korisničke podatke
                  </v-btn>
                  <v-btn
                    v-else
                    outlined
                    class="text-none"
                    color="primary"
                    @click="openDialogParent(1, 'reset')"
                  >
                    <v-icon left color="red">mdi-account-key</v-icon>
                    Promjena lozinke
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-else class="d-flex justify-center">
              <h3>Nema podataka roditelju/staratelju</h3>
            </v-container>
            <div
              v-if="Object.keys(parent1Info).length !== 0"
              style="height: 1px; background: linear-gradient(90deg,#fff,#084776,#fff);"
            ></div>
            <!--Card body-->
            <v-row
              v-for="(value, propertyName, index) in parent1Info"
              :key="index"
            >
              <v-col cols="4" class="d-flex justify-end">
                <p class="font-weight-bold">{{ propertyName }}:</p>
              </v-col>
              <v-col>
                <p>{{ value ? value : "-" }}</p>
              </v-col>
            </v-row>
          </v-card>
          <!--Parent2 info-->
          <v-card class="mb-3" outlined>
            <!--Card title-->
            <v-container
              v-if="Object.keys(parent2Info).length !== 0"
              class="d-flex justify-center"
            >
              <v-row justify="center" align="center">
                <v-col cols="12" md="6" class="text-center">
                  <h3 class="primary--text pb-2">
                    <v-icon class="mb-1" color="primary" left
                      >mdi-account</v-icon
                    >
                    Podaci o roditelju/staratelju
                  </h3>
                </v-col>
                <v-col cols="12" md="6" class="text-center" v-if="$checkPermission('change_password_for_parents')">
                  <v-btn
                    v-if="!has_sumit_login_p2"
                    outlined
                    class="text-none"
                    color="primary"
                    @click="openDialogParent(2, 'give')"
                  >
                    <v-icon left color="red">mdi-account-key</v-icon>
                    Dodijeli korisničke podatke
                  </v-btn>
                  <v-btn
                    v-else
                    outlined
                    class="text-none"
                    color="primary"
                    @click="openDialogParent(2, 'reset')"
                  >
                    <v-icon left color="red">mdi-account-key</v-icon>
                    Promjena lozinke
                  </v-btn>
                </v-col>
              </v-row>
              <div
                style="height: 1px; background: linear-gradient(90deg,#fff,#084776,#fff);"
              ></div>
            </v-container>
            <v-container v-else class="d-flex justify-center">
              <h3>Nema podataka roditelju/staratelju</h3>
            </v-container>
            <div
              v-if="Object.keys(parent2Info).length !== 0"
              style="height: 1px; background: linear-gradient(90deg,#fff,#084776,#fff);"
            ></div>
            <!--Card body-->
            <v-row
              v-for="(value, propertyName, index) in parent2Info"
              :key="index"
            >
              <v-col cols="4" class="d-flex justify-end">
                <p class="font-weight-bold">{{ propertyName }}:</p>
              </v-col>
              <v-col>
                <p>{{ value ? value : "-" }}</p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!--Action buttons-->

        <v-col
          cols="12"
          md="3"
          class="fix-element "
        >
          <v-btn
            v-if="!has_identity && $checkPermission('edu_id_button')"
            dark
            depressed
            :class="
              loading ? 'disable-events mb-4 text-none' : 'mb-4 text-none'
            "
            height="50px"
            color="red"
            block
            @click="dialog = true"
            :loading="loading"
          >
            <img
              height="25px"
              class="pr-4"
              src="../../../assets/img/eduID-white.svg"
            />Dodijeli eduID identitet
          </v-btn>
          <v-btn v-else-if="has_identity && $checkPermission('edu_id_button')"
            dark
            depressed
            class="mb-4 text-none"
            height="50px"
            color="red"
            block
            @click="passwordReset()"
          >
            <img
              height="25px"
              class="pr-4"
              src="../../../assets/img/eduID-white.svg"
            />Promjena lozinke
          </v-btn>
          <v-btn
            color="primary"
            depressed
            class="text-none"
            height="50px"
            @click="showAddForm()"
            block
            v-if="$checkPermission('edit_users_button')"
          >
            <v-icon color="white" left>mdi-pencil</v-icon>
            Uredi podatke
          </v-btn>
          <!--Dodati mogucnost za brisanje skole-->
          <v-btn
            class="mt-4 custom-btn-red text-none"
            height="50px"
            color="red"
            @click="checkUserEnrollment"
            block
            outlined
            v-if="$checkPermission('dismissal_students_from_school_button')"
          >
            <!--            <v-icon color="red" left>mdi-logout</v-icon>-->
            <v-icon color="red" left>mdi-account-arrow-right</v-icon>
            Ispiši učenika iz škole
          </v-btn>

          <v-btn
                  v-if="all_diplomas.length && $checkPermission('review_diplomas_button')"
                  class="mt-4 custom-btn-blue text-none"
                  height="50px"
                  color="primary"
                  @click="dialog_testimonial = true"
                  block
                  outlined
          >
              <v-icon color="primary" left>mdi-file-find</v-icon>
              Pregled svjedodžbi
          </v-btn>
          <v-btn
              color="primary"
              depressed
              class="text-none mt-5"
              height="50px"
              @click="showFormForDocuments()"
              block
              v-if="$checkPermission('documents_button')"
          >
            <v-icon color="white" left>mdi-file</v-icon>
            Dokumenti
          </v-btn>
          <v-btn
              color="success"
              depressed
              class="text-none mt-5"
              height="50px"
              @click="showDepartmentEnrollmentHistory()"
              block
              v-if="$checkPermission('rodijak')"
          >
            <v-icon color="white" left>mdi-history</v-icon>
            Povijest odjeljenja
          </v-btn>
          <v-dialog v-model="departmentEnrollmentHistoryDialog" width="900">
            <v-card>
              <v-card-title class="primary white--text justify-center">Povijest odjeljanja koje je učenik pohađao</v-card-title>
              <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="department_enrollments"
                    :loading="loading"
                    class="elevation-1 mt-3"
                    loading-text="Traženje..."
                ></v-data-table>
              </v-card-text>
            </v-card>

          </v-dialog>
          <!--          <v-btn class="mt-4 custom-btn-red text-none" height="50px" color="red" @click="deleteItem()"-->
          <!--                 block outlined>-->
          <!--            <v-icon color="red" left>mdi-delete</v-icon>-->
          <!--            Obriši učenika-->
          <!--          </v-btn>-->
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title primary-title>
            <v-icon left>mdi-key</v-icon>
            Dodijeli eduID identitet
          </v-card-title>

          <v-card-text style="padding-top: 20px;">
            <!--{{ deleteText }}-->
            <!--<v-text-field v-model="password" outlined label="Unesite novu lozinku" @click:append="show1 = !show1" hide-details :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"></v-text-field>-->
            <!--<div v-if="password">-->
            <!--<span class="font-weight-grey">Nova lozinka: </span>-->
            <!--<span class="font-weight-bold">{{password}}</span>-->
            <!--</div>-->

            <v-checkbox
              v-model="checkbox"
              label="Pošalji na mail?"
              color="primary"
            ></v-checkbox>
            <v-text-field
              v-if="checkbox"
              v-model="email"
              label="Privatni email"
              outlined
            ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialog = false" depressed large outlined
              >Odustani</v-btn
            >
            <v-btn
              @click="giveIdentity()"
              color="primary"
              :loading="loading"
              :class="loading ? 'disable-events' : ''"
              depressed
              large
              >Dodijeli identitet
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_removeRole" width="500">
        <v-card>
          <v-card-title
              primary-title>
            Jeste li sigurni?
          </v-card-title>

          <v-card-text style="padding-top: 20px;">
            Operacija koju ste zatražali može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite ispisati učenika iz Vaše škole?
            <br><br>
            <v-checkbox label="Prikaži učenika u izvještajima za ovu školsku godinu?" v-model="form.keep_student"></v-checkbox>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="(dialog_removeRole = false, form.keep_student = false)" depressed large outlined>Odustani</v-btn>
            <v-btn @click="deleteRole()" color="error" depressed large>Ispiši</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_canNotRemoveRole" width="500">
        <v-card>
          <v-card-title
              primary-title>
            Nije moguće ukloniti učenika iz škole!
          </v-card-title>

          <v-card-text style="padding-top: 20px;">
            Korisnik još uvijek postoji u razredu, te ga nije moguće izbrisati iz škole. Ukoliko želite izbrisati korisnika iz škole, prvo ste dužni izbrisati istog iz tekućeg razreda!   <br><br>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="(dialog_canNotRemoveRole = false, form.keep_student = false)" depressed large outlined>Odustani</v-btn>
            &nbsp;
            <router-link :to="`/admin/odjeljenje/pregled/${this.studentDepartment}`">
              <v-btn color="error" depressed large>Ispiši iz razreda!</v-btn>
            </router-link>

          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog v-model="dialog_parent" width="500">
        <v-card>
          <v-card-title primary-title>
            <v-icon left>mdi-key</v-icon>
            {{ parent_dialog_text }}
          </v-card-title>

          <v-card-text style="padding-top: 20px;">
            <v-checkbox
              v-model="checkbox_parent"
              label="Pošalji na mail?"
              color="primary"
            ></v-checkbox>
            <v-text-field
              v-if="checkbox_parent"
              v-model="email_parent"
              label="Privatni email"
              outlined
            ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="dialog_parent = false"
              depressed
              large
              outlined
              class="text-none"
              >Odustani</v-btn
            >
            <v-btn
              @click="
                giveParentUserData(
                  parent_dialog_text === 'Dodijeli korisničke podatke'
                    ? 'give'
                    : 'reset'
                )
              "
              color="primary"
              :loading="loading_login"
              :class="loading_login ? 'disable-events' : ''"
              depressed
              large
              class="text-none"
              >{{ parent_dialog_text }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_testimonial" width="500">
            <v-card>
                <v-card-title>
                    Popis svjedodžbi učenika
                </v-card-title>
                <v-card-text>
                    <v-list-item
                            v-for="diploma in all_diplomas"
                            :key="diploma.id"
                            class="px-4 px-sm-8 py-3 mb-4 flex-column flex-sm-row"
                            :class="{ 'optional-subject-list': $vuetify.breakpoint.xs }"
                            style="border: thin solid rgba(0, 0, 0, 0.12)"
                    >
                        <v-list-item-content three-line>
                            <v-list-item-title
                                    style="white-space: normal"
                                    class="mb-3 font-weight-medium title"
                            >
                                Pregled Svjedodžbe
                            </v-list-item-title>
                            <v-list-item-subtitle
                                    v-for="(val, key, index) in optimizeDiploma(diploma)"
                                    :key="index"
                                    class="mb-1"
                                    style="white-space: normal; font-size: 16px"
                            >
                                <span class="font-weight-light"> {{ key }}: </span>
                                {{ val ? val : "-" }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class="align-self-auto">
                            <v-col class="pa-0">
                                <v-btn
                                        depressed
                                        class="text-none mb-3"
                                        color="primary"
                                        block
                                        target="_blank"
                                        @click="goToDiploma(diploma)"
                                >
                                    <v-icon class="mr-2" size="20"> mdi-file-find</v-icon>
                                    Pregled
                                </v-btn>
                            </v-col>
                        </v-list-item-action>
                    </v-list-item>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="dialog_testimonial = false"
                            depressed
                            large
                            outlined
                            class="text-none"
                    >Odustani</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { serverBus } from "../../../main";
import ApiV2 from "@/services/ApiV2";

export default {
    components: {},
  data() {
    return {
      studentDepartment:null,
      dialog_canNotRemoveRole:false,
      dialog_parent: false,
      loading: false,
      loading_login: false,
      studentData: {},
      parent1Info: {},
      parent2Info: {},
      user_roles: [],
      dialog_removeRole: false,
      dialog_testimonial: false,
      password: "",
      form: {},
      email: "",
      email_parent: "",
      email_parent1: "",
      email_parent2: "",
      id_parent1: null,
      id_parent2: null,
      id_parent: null,
      first_name: "",
      last_name: "",
      has_identity: null,
      has_sumit_login_p1: null,
      has_sumit_login_p2: null,
      logged_user: false,
      checkbox: false,
      checkbox_parent: false,
      dialog: false,
      student_parent1: [],
      student_parent2: [],
      parent_dialog_text: "",
      full_name_p1: "",
      full_name_p2: "",
      active_parent: null,
      all_diplomas: [],
      departmentEnrollmentHistoryDialog: false,
      department_enrollments:[],
      headers: [
        { text: 'Odjeljenje', align: 'start', value: 'department.label'},
        { text: 'Škola', value: 'department.school.name' },
        { text: 'Smjer', value: 'department.educational_field.name' },
        { text: 'Školska godina', value: 'department.school_year.title' },
      ],
    };
  },
  created() {
    //Get student data
    this.logged_user =
      this.$getUser().id == this.$route.params.ucenik_id ? true : false;
    const studentId = this.$route.params.ucenik_id;
    let table = "ucenik" + "/" + `${studentId}`;
    this.$store.commit("setTable", table);
    this.getData();
    // this.$axios.post('ucenik/' + `${studentId}`).then(response => {
    //   let test = response.data
    //   this.email = test.email_private
    //   this.has_identity = test.has_identity
    //   this.optimizeApiData(response.data)
    // });

    ApiV2.get("users/" + studentId, {
      params: {
        with: ["parentOne", "parentTwo"],
      },
    }).then((response) => {
      let student = response.data;
      this.email = student.email_private;
      this.has_identity = student.has_identity;
      this.optimizeApiData(response.data, "student");

      if (student.parent_one != null) {
        this.student_parent1 = student.parent_one;
        this.email_parent1 = this.student_parent1.email_private;
        this.id_parent1 = this.student_parent1.id;
        this.has_sumit_login_p1 = this.student_parent1.has_sumit_login;
        this.full_name_p1 = this.student_parent1.full_name;
        this.optimizeApiData(this.student_parent1, "parent_1");
      }
      if (student.parent_two != null) {
        this.student_parent2 = student.parent_two;
        this.email_parent2 = this.student_parent2.email_private;
        this.id_parent2 = this.student_parent2.id;
        this.has_sumit_login_p2 = this.student_parent2.has_sumit_login;
        this.full_name_p2 = this.student_parent2.full_name;
        this.optimizeApiData(this.student_parent2, "parent_2");
      }
    });

    if(this.$route.name === 'StudentDetailsIndex')
      this.getTestimonial()
    this.getUserDepartmentEnrollments()
  },

  computed: {
    currentSchool() {
      return this.$store.getters.getSchool;
    },
    enrolledStudent() {
      return this.$store.getters.getEnrolledStudent;
    },
  },

  methods: {
    getUserDepartmentEnrollments() {
      ApiV2.post('/user_department_enrollments',
          { user_id: this.$route.params.ucenik_id }
      ).then((response) => {
        this.department_enrollments = response.data
      });
    },

    showDepartmentEnrollmentHistory(){
      this.departmentEnrollmentHistoryDialog = true
    },
    passwordReset() {
      serverBus.$emit(
        "show-reset-password-dialog",
        "ucenik",
        { id: this.$route.params.ucenik_id },
        this.email,
        this.first_name,
        this.last_name,
        this.logged_user
      );
    },

    giveIdentity() {
      this.loading = true;
      let reqBody = {};
      if (this.checkbox) {
        reqBody.email = this.email;
      }
      this.$axios
        .post("/sso/identity/" + this.$route.params.ucenik_id, reqBody)
        .then((response) => {
          let user = response.data;
          let email = user.email;
          let password = user.password;
          // serverBus.$emit('give-identity-for-user', user);
          this.$router.push({
            name: "Print",
            query: {
              email: email,
              password: password,
              first_name: this.first_name,
              last_name: this.last_name,
            },
            params: {
              table: "print",
              resource_id: this.$route.params.ucenik_id,
            },
          });
        })
        .catch(function() {
          serverBus.$emit(
            "show-snackbar",
            false,
            "Nemoguće dodijeliti identitet!!"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openDialogParent(val, note) {
      this.active_parent = val;
      if (note === "give")
        this.parent_dialog_text = "Dodijeli korisničke podatke";
      else if (note === "reset") this.parent_dialog_text = "Promjena lozinke";
      if (val === 1) {
        this.email_parent = this.email_parent1;
        this.id_parent = this.id_parent1;
      } else if (val === 2) {
        this.email_parent = this.email_parent2;
        this.id_parent = this.id_parent2;
      }
      this.dialog_parent = true;
    },

    giveParentUserData(note) {
      this.loading_login = true;
      let reqBody = {};
      if (this.checkbox_parent) {
        reqBody.email = this.email_parent;
      }
      if (note === "give") {
        this.$axios
          .post("/auth/" + this.id_parent + "/issue", reqBody)
          .then((response) => {
            // console.log(response.data)
            let username = response.data.username;
            let password = response.data.password;
            this.$router.push({
              name: "PrintParent",
              query: {
                username: username,
                password: password,
                full_name:
                  this.active_parent === 1
                    ? this.full_name_p1
                    : this.full_name_p2,
              },
              params: {
                table: "print",
                resource_id: this.$route.params.ucenik_id,
              },
            });
          })
          .catch(function() {
            serverBus.$emit(
              "show-snackbar",
              false,
              "Nemoguće dodijeliti korisničke podatke!!"
            );
          })
          .finally(() => {
            this.loading_login = false;
            this.dialog_parent = false;
          });
      } else if (note === "reset") {
        this.$axios
          .post("/auth/" + this.id_parent + "/reset", reqBody)
          .then((response) => {
            let username = response.data.username;
            let password = response.data.password;
            this.$router.push({
              name: "PrintParent",
              query: {
                username: username,
                password: password,
                full_name:
                  this.active_parent === 1
                    ? this.full_name_p1
                    : this.full_name_p2,
              },
              params: {
                table: "print",
                resource_id: this.$route.params.ucenik_id,
              },
            });
          })
          .catch(function() {
            serverBus.$emit(
              "show-snackbar",
              false,
              "Nemoguće promjeniti lozinku!!"
            );
          })
          .finally(() => {
            this.loading_login = false;
            this.dialog_parent = false;
          });
      }
    },

    optimizeApiData(studentData, value) {
      if (value == "student") {
        this.first_name = studentData.first_name;
        this.last_name = studentData.last_name;
        let student_sex = "";
        if (studentData.sex == "z") {
          student_sex = "Žensko";
        } else if (studentData.sex == "m") {
          student_sex = "Muško";
        } else {
          student_sex = "-";
        }
        const identityLabel = studentData.jmbg ? "JMBG" : "OIB";
        const identityValue = studentData.jmbg || studentData.oib;
        this.studentData = {
          Ime: studentData.first_name,
          Prezime: studentData.last_name,
          [identityLabel]: identityValue,
          "Datum rođenja": studentData.date_of_birth,
          "Mjesto rođenja": studentData.birth_place,
          "Država rođenja": studentData.country_of_birth,
          Državljanstvo: studentData.citizenship,
          Spol: student_sex,
          "E-mail": studentData.email_private,
          "Službeni e-mail": studentData.email,
          Telefon: studentData.phone,
        };
      } else if (value == "parent_1") {
        let parent1_sex = "";
        if (studentData.sex == "z") {
          parent1_sex = "Žensko";
        } else if (studentData.sex == "m") {
          parent1_sex = "Muško";
        } else {
          parent1_sex = "-";
        }

        let parent1_employment_status = "";
        if (studentData.employment_status == "nezaposlen") {
          parent1_employment_status = "NE";
        } else if (studentData.employment_status == "zaposlen") {
          parent1_employment_status = "DA";
        } else {
          parent1_employment_status = "-";
        }

        this.parent1Info = {
          Ime: studentData.first_name,
          Prezime: studentData.last_name,
          JMBG: studentData.jmbg,
          "Datum rođenja": studentData.date_of_birth,
          // 'Mjesto rođenja': studentData.birth_place,
          // 'Država rođenja': studentData.country_of_birth,
          Spol: parent1_sex,
          "E-mail": studentData.email_private,
          Telefon: studentData.phone,
          Zanimanje: studentData.profession,
          "Zaposlen/a": parent1_employment_status,
        };
      } else if (value == "parent_2") {
        let parent2_sex = "";
        if (studentData.sex == "z") {
          parent2_sex = "Žensko";
        } else if (studentData.sex == "m") {
          parent2_sex = "Muško";
        } else {
          parent2_sex = "-";
        }

        let parent2_employment_status = "";
        if (studentData.employment_status == "nezaposlen") {
          parent2_employment_status = "NE";
        } else if (studentData.employment_status == "zaposlen") {
          parent2_employment_status = "DA";
        } else {
          parent2_employment_status = "-";
        }

        this.parent2Info = {
          Ime: studentData.first_name,
          Prezime: studentData.last_name,
          JMBG: studentData.jmbg,
          "Datum rođenja": studentData.date_of_birth,
          // 'Mjesto rođenja': studentData.birth_place,
          // 'Država rođenja': studentData.country_of_birth,
          Spol: parent2_sex,
          "E-mail": studentData.email_private,
          Telefon: studentData.phone,
          Zanimanje: studentData.profession,
          "Zaposlen/a": parent2_employment_status,
        };
      }

      //Naknadno napraviti request za podatke od roditelja učenika
      // this.parent1Info = {}

      // this.parent2Info = {}
    },

    getData() {
      if (!this.logged_user) {
        this.$axios.post(this.$getTable() + "").then((response) => {
          // console.log(response.data)
          let student = response.data;
          this.user_roles = student.model_has_roles;
        });
      } else {
        this.user = this.$getUser();
        this.optimizeData(this.$getUser());
      }
    },

    getTestimonial() {
        ApiV2.post('/diplomas/get_previous_diplomas',
            { user_id: this.$route.params.ucenik_id, department_id: this.$route.params.odjeljenje_id }
        ).then((response) => {
            this.all_diplomas = response.data
        });
    },

    optimizeDiploma(item) {
          let conduct = 0;

          switch (item.conduct) {
              case 1:
                  conduct = "Loše";
                  break;
              case 2:
                  conduct = "Zadovoljavajuće";
                  break;
              case 3:
                  conduct = "Dobro";
                  break;
              case 4:
                  conduct = "Vrlo dobro";
                  break;
              case 5:
                  conduct = "Uzorno";
                  break;
              case 6:
                  conduct = "Neocijenjeno";
                  break;
              default:
                  console.log("Nema vladanja");
                  break;
          }

          return {
              "Prosječna ocjena": item.average_grade,
              "Zaključna ocjena": item.final_success,
              Vladanje: conduct,
              "Opravdani sati": item.justified_hours,
              "Neopravdani sati": item.unjustified_hours,
          };
      },

      async goToDiploma(diploma) {
        window.open(
            `/uvjerenje/${diploma.uuid}`,
            "_blank"
        );
      },

    deleteItem() {
      serverBus.$emit("show-delete-item-dialog", "ucenik", {
        id: this.$route.params.ucenik_id,
      });
    },
    checkUserEnrollment(){

      const id = this.$route.params?.ucenik_id;
      let requestData = {
        school_id: localStorage.getItem('school_id'),
        school_year_id: localStorage.getItem('school_year_id'),
        id: id,
      }

      ApiV2.post(`department_enrollment/is_enrolled_in_department`, requestData).then(response => {
        console.log(response.data);

        if(response.data === -1){
              this.dialog_removeRole=true;
            }else{
              this.dialog_canNotRemoveRole=true;
              this.studentDepartment = response.data[0].department_id
            }
          });
    },
    deleteRole() {
      let model_id = null;
      for (var prop in this.user_roles) {
        if (this.user_roles[prop].role_id === 10) {
          model_id = this.user_roles[prop].id;
        }
      }
      this.form.model_has_role_id = model_id;

      ApiV2
        .post(
            'roles/revoke_user_role',
          this.form
        )
        .then(() => {
          this.$router.push("/admin/ucenik");
          this.dialog_removeRole = false;
        });
    },

    showAddForm: function() {
      this.$router.push({
        name: "StudentAddView",
        params: { table: "ucenik", resource_id: this.$route.params.ucenik_id },
      });

      //serverBus.$emit('show-student-add-form', this.$route.params.ucenik_id);
    },
    showFormForDocuments: function() {
      this.$router.push({
        name: "StudentDocumentsView",
        params: {table: "ucenik",resource_id: this.$route.params.ucenik_id },
      });
    },
  },
};
</script>

<style>
.disable-events {
  pointer-events: none;
}

.custom-btn-blue {
    border: 1px rgba(8, 71, 118, 0.20) solid !important;
    border-radius: 5px;
}
</style>
